<template>
    <form class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            caption="編輯日曆事件"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="md form-table">
                    <table>
                        <tr>
                            <th><label for="sub">標題</label></th>
                            <td>
                                <div class="cp input text" :class="[errors.has('sub')? 'is-error': '']" :data-error="errors.first('sub')">
                                    <input v-model="sub" type="text" v-validate="'required'" name="sub" id="sub">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="allDate">全天</label></th>
                            <td>
                                <div class="cp input checkbox">
                                    <input v-model="allDate" type="checkbox" name="allDate" id="allDate" @change="setTime">
                                    <label for="allDate"></label>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="allDate">
                            <th><label for="startTime">{{ $t('site.noun.startdate') }}</label></th>
                            <td>
                                <cpDatePicker
                                    type="date"
                                    key="startTimeDate"
                                    :hideLabel="true"
                                    :errorStatus="errors.has('startTimeDate')"
                                    :errorMsg="errors.first('startTimeDate')"
                                    :value="startTimeDate"
                                    @input="setStartTimeDate"
                                    v-validate="'required'"
                                    name="startTimeDate"
                                    ref="startTimeDate"
                                ></cpDatePicker>
                            </td>
                        </tr>
                        <tr v-else>
                            <th><label for="startTime">{{ $t('site.noun.startdate') }}</label></th>
                            <td>
                                <cpDatePicker
                                    type="datetime-local"
                                    key="startTimeDateTime"
                                    :hideLabel="true"
                                    :errorStatus="errors.has('startTimeDateTime')"
                                    :errorMsg="errors.first('startTimeDateTime')"
                                    :value="startTimeDateTime"
                                    @input="setStartTimeDateTime"
                                    v-validate="'required'"
                                    name="startTimeDateTime"
                                    ref="startTimeDateTime"
                                ></cpDatePicker>
                            </td>
                        </tr>
                        <tr v-if="allDate">
                            <th><label for="endTime">{{ $t('site.noun.enddate') }}</label></th>
                            <td>
                                <cpDatePicker
                                    type="date"
                                    key="endTimeDate"
                                    :hideLabel="true"
                                    :errorStatus="errors.has('endTimeDate')"
                                    :errorMsg="errors.first('endTimeDate')"
                                    :value="endTimeDate"
                                    @input="setEndTimeDate"
                                    v-validate="'required|isAfter:startTimeDate'"
                                    name="endTimeDate"
                                    ref="endTimeDate"
                                ></cpDatePicker>
                            </td>
                        </tr>
                        <tr v-else>
                            <th><label for="endTime">{{ $t('site.noun.enddate') }}</label></th>
                            <td>
                                <cpDatePicker
                                    type="datetime-local"
                                    key="endTimeDateTime"
                                    :hideLabel="true"
                                    :errorStatus="errors.has('endTimeDateTime')"
                                    :errorMsg="errors.first('endTimeDateTime')"
                                    :value="endTimeDateTime"
                                    @input="setEndTimeDateTime"
                                    v-validate="'required|isAfter:startTimeDateTime'"
                                    name="endTimeDateTime"
                                    ref="endTimeDateTime"
                                ></cpDatePicker>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="cal">月曆</label></th>
                            <td>
                                <select v-model="cal">
                                    <option v-for="cal in editableCals" :value="cal.sn" :key="'Cal-'+ cal.sn">{{ cal.sub }}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="location">地點</label></th>
                            <td>
                                <div class="cp input text">
                                    <input type="text" v-model="location" id="location">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th><label for="desc">敘述</label></th>
                            <td><textarea v-model="desc" id="desc"></textarea></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import cpDatePicker from '@/components/cpDatePicker'
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            cpDatePicker,
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){

            return {
                allDate: false,
                sn: null,
                sub: null,
                startTime: null,
                endTime: null,
                location: null,
                cal: null,
                desc: null
            }
        },
        computed: {
            editableCals: function(){ //可編輯的日曆
                let $source = this.content.extend.source.filter(item => {
                    return item.editable === true
                })

                return $source;
            },
            startTimeDate: function(){
                let $time = this.startTime;

                let _year = $time.year,
                    _month = $time.month,
                    _date = $time.date;

                return _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date);
            },
            startTimeDateTime: function(){
                let $time = this.startTime;

                let _year = $time.year,
                    _month = $time.month,
                    _date = $time.date,
                    _hour = $time.hour,
                    _minutes = $time.minutes;

                return _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date) +'T'+ this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount(_minutes);
            },
            endTimeDate: function(){
                let $time = this.endTime;

                let _year = $time.year,
                    _month = $time.month,
                    _date = $time.date;

                return _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date);
            },
            endTimeDateTime: function(){
                let $time = this.endTime;

                let _year = $time.year,
                    _month = $time.month,
                    _date = $time.date,
                    _hour = $time.hour,
                    _minutes = $time.minutes;

                return _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date) +'T'+ this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount(_minutes);
            },
            btns: function(){

                let $edit = {
                        text: this.$t('site.status.confirm'),
                        themes: 'major',
                        func: 'edit',
                    },
                    $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                return [
                    $edit,
                    $cancel,
                ]
            },
        },
        methods: {
            setStartTimeDate: function(_val){
                let $val = _val.split(/\-/g);

                this.$set(this, 'startTime', {
                    year: parseInt($val[0], 10),
                    month: parseInt($val[1], 10),
                    date: parseInt($val[2], 10),
                    hour: 0,
                    minutes: 0
                });
            },
            setStartTimeDateTime: function(_val){
                let $val = _val.split(/\-|T|:/g);

                this.$set(this, 'startTime', {
                    year: parseInt($val[0], 10),
                    month: parseInt($val[1], 10),
                    date: parseInt($val[2], 10),
                    hour: parseInt($val[3], 10),
                    minutes: parseInt($val[4], 10)
                });
            },
            setEndTimeDate: function(_val){
                let $val = _val.split(/\-/g);

                this.$set(this, 'endTime', {
                    year: parseInt($val[0], 10),
                    month: parseInt($val[1], 10),
                    date: parseInt($val[2], 10),
                    hour: 0,
                    minutes: 0
                });
            },
            setEndTimeDateTime: function(_val){
                let $val = _val.split(/\-|T|:/g);

                this.$set(this, 'endTime', {
                    year: parseInt($val[0], 10),
                    month: parseInt($val[1], 10),
                    date: parseInt($val[2], 10),
                    hour: parseInt($val[3], 10),
                    minutes: parseInt($val[4], 10)
                });
            },
            setTime: function(){
                let $time = null;

                if( this.allDate ){
                    $time = this.content.extend.computedTime(this.startTime, {
                        date: 1
                    });
                }else {
                    $time = this.content.extend.computedTime(this.startTime, {
                        hour: 1
                    });
                }

                this.$set(this, 'endTime', $time);
            },
            timeDifference: function(time1, time2){
                return Math.abs(new Date(time1) - new Date(time2));
            },
            // timeToString: function(obj){
            //     let _year = obj.year,
            //         _month = obj.month,
            //         _date = obj.date,
            //         _hour = obj.hour,
            //         _minutes = obj.minutes;

            //     let _allDate = this.allDate;

            //     let _result = null;

            //     if( _year == 0 && _month == 0 && _date == 0 && _hour == 0 && _minutes == 0 ){
            //         _result = '';
            //     }else {
            //         _result = _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date);

            //         if( _allDate ){
            //             _result = _result +'T'+ this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount(_minutes)
            //         }
            //     }

            //     return _result;
            // },
            // timeToObj: function(e, data){

            //     let _val = e.target.value;

            //     if( _val === '' ){
            //         this[data].year = 0;
            //         this[data].month = 0;
            //         this[data].date = 0;
            //         this[data].hour = 0;
            //         this[data].minutes = 0;
            //     }

            //     let $val = _val.split(/\-|T|:/g);

            //     this[data].year = parseInt($val[0]);
            //     this[data].month = parseInt($val[1]);
            //     this[data].date = parseInt($val[2]);

            //     if( $val[3] ){
            //         this[data].hour = parseInt($val[3]);
            //     }

            //     if( $val[4] ){
            //         this[data].minutes = parseInt($val[4]);
            //     }
            // },
            edit: function(){
                let _startYear = this.startTime.year,
                    _startMonth = this.startTime.month,
                    _startDate = this.startTime.date,
                    _startHour = this.startTime.hour,
                    _startMinutes = this.startTime.minutes,
                    _endYear = this.endTime.year,
                    _endMonth = this.endTime.month,
                    _endDate = this.endTime.date,
                    _endHour = this.endTime.hour,
                    _endMinutes = this.endTime.minutes;

                if( this.allDate ){
                    _startHour = 0;
                    _startMinutes = 0;
                    _endHour = 0;
                    _endMinutes = 0;
                }

                this.$validator.validate().then(result => {
                    if (!result){
                        console.log('沒通過');
                    }else {
                        this.content.extend.updateEvent({
                            startTime: {
                                year: _startYear,
                                month: _startMonth,
                                date: _startDate,
                                hour: _startHour,
                                minutes: _startMinutes
                            },
                            endTime: {
                                year: _endYear,
                                month: _endMonth,
                                date: _endDate,
                                hour: _endHour,
                                minutes: _endMinutes
                            },
                            sn: this.sn,
                            sub: this.sub,
                            desc: this.desc,
                            cal: this.cal,
                            location: this.location
                        }, true);

                        this.closeAll();
                    }
                });
            },
            closeAll: function(){
                this.$emit('sendEvent', 'clearPopUp', 'all');
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp');

                if( this.content.extend.close ){
                    this.content.extend.close();
                }
            }
        },
        created: function(){ //先把綁進來的資料格式化到 date
            let $node = this.content.node,
                $startTime = $node.startTime,
                $endTime = $node.endTime;

            let _allDate = false;

            if( $startTime.hour === 0 && $startTime.minutes === 0 && $endTime.hour === 0 && $endTime.minutes === 0 ){
                _allDate = true;
            }

            this.startTimeDateComputed = 0;
            this.startTimeDateTimeComputed = 0;
            this.endTimeDateComputed = 0;
            this.endTimeDateTimeComputed = 0;

            this.allDate = _allDate;
            this.startTime = $startTime;
            this.sn = $node.sn;
            this.sub = $node.sub;
            this.desc = $node.desc;
            this.cal = $node.cal;
            this.location = $node.location;
            this.endTime = $endTime;
        }
    }
</script>

<style scoped lang="scss">

    textarea {
        min-height: 60px;
    }
</style>
